"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerPreferencesTransportValidation = exports.HaulerPreferenceTransportValidation = exports.HaulerPreferencesTransport = exports.HaulerPreferenceTransport = exports.EnableWaysteInvoiceIssueReceiptType = exports.EnableWaysteInvoicePaymentReceiptType = exports.EnableRollOffInvoicePaidType = exports.EnableRollOffOrderConfirmationType = exports.EnableWaysteAutopayFailureType = exports.EnableWaysteAutopayReceiptType = exports.EnableRollOffDayBeforeServiceReminderType = exports.EnableRollOffDayOfServiceReminderType = exports.EnableOrderCancellationNotificationsType = exports.EnableEnRouteNotificationsType = exports.OnlineCheckoutCutoffTimeType = exports.OnlineCheckoutAdvanceDaysType = exports.OnlineCheckoutSpecificDatesDisabledType = exports.OnlineCheckoutDaysOfWeekDisabledType = exports.StopCardFieldCustomizationType = exports.AddMissingPaymentFeeOnWaysteDashboardType = exports.AchRemittanceInfoType = exports.AlwaysShowRemittanceInfoOnUnpaidInvoicesType = exports.EnableServiceAgreementsType = exports.EnforceAvailabilityForOnlineBookingType = exports.FeatureFlagWaysteWhiteLabelType = exports.FeatureFlagWaysteCommercialType = exports.WaysteTaxableLineItemsType = exports.UseDumpType = exports.HaulerPreferenceKey = exports.HaulerPreferenceValueValidation = exports.HaulerPreferenceValueInternal = exports.HaulerPreferenceValue = exports.WhiteLabelSettingsValue = exports.OnlineCheckoutSpecificDatesDisabledValue = exports.OnlineCheckoutDaysOfWeekDisabledValue = exports.StopCardFieldCustomizationValue = exports.SapTaxableLineItemsValue = exports.WaysteTaxableLineItemsValue = exports.HaulerPreferenceNumberValue = exports.HaulerPreferenceStringValue = exports.HaulerPreferenceBooleanValue = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const invoice_1 = require("../invoice");
//////////////////////////////////////////////////////////////////////////
// ** IF YOU ARE ADDING A NEW TYPE AND YOU WOULD LIKE A DEFAULT VALUE,  **
// ** CREATE A MIGRATION ADDING THE PREFERENCE IN WITH A NULL HAULER ID **
//////////////////////////////////////////////////////////////////////////
// Add a new type here:
// 1. Create a new preference type if applicable
// 2. Add the type to the HaulerPreferenceValue union
// 3. Add the type to the HaulerPreferenceValueInternal union
// 4. Add the type to the HaulerPreferenceKey union
// 5. Add the type to the Actual type section
// 6. Add the type to the HaulerPreferenceTransport union
// Don't forget to add the type to the exported types at the bottom of the file
// update createNewPreference function in the Hauler Preference entity to handle the new type
//////////////////////////////////////////////////////
// Hauler Preferences Types
//////////////////////////////////////////////////////
exports.HaulerPreferenceBooleanValue = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('boolean'),
    value: typebox_1.Type.Boolean(),
});
exports.HaulerPreferenceStringValue = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('string'),
    value: typebox_1.Type.String(),
});
exports.HaulerPreferenceNumberValue = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('number'),
    value: typebox_1.Type.Number(),
});
////////////////////////////////////////////////////////
exports.WaysteTaxableLineItemsValue = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('WaysteTaxableLineItemsArray'),
    value: typebox_1.Type.Array(invoice_1.DefaultLineItem),
});
exports.SapTaxableLineItemsValue = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('SapTaxableLineItemsArray'),
    value: typebox_1.Type.Array(invoice_1.DefaultLineItem),
});
const FieldCustomizationValue = typebox_1.Type.Object({
    fieldKey: common_1.StopCardField,
    isEnabled: typebox_1.Type.Boolean(),
});
exports.StopCardFieldCustomizationValue = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('StopCardFieldCustomization'),
    value: typebox_1.Type.Object({
        fieldsAlwaysShown: typebox_1.Type.Array(FieldCustomizationValue),
        fieldsExpandable: typebox_1.Type.Array(FieldCustomizationValue),
        warnings: typebox_1.Type.Object({
            displayOutStandingBalances: typebox_1.Type.Boolean(),
            showSeviceAgreementNotSigned: typebox_1.Type.Boolean(),
        }),
    }),
});
// Online Checkout Availability Preferences
exports.OnlineCheckoutDaysOfWeekDisabledValue = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('OnlineCheckoutDaysOfWeekDisabled'),
    value: typebox_1.Type.Object({
        sunday: typebox_1.Type.Boolean(),
        monday: typebox_1.Type.Boolean(),
        tuesday: typebox_1.Type.Boolean(),
        wednesday: typebox_1.Type.Boolean(),
        thursday: typebox_1.Type.Boolean(),
        friday: typebox_1.Type.Boolean(),
        saturday: typebox_1.Type.Boolean(),
    }),
});
exports.OnlineCheckoutSpecificDatesDisabledValue = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('OnlineCheckoutSpecificDatesDisabled'),
    value: typebox_1.Type.Array(typebox_1.Type.String({ format: 'date' })),
});
exports.WhiteLabelSettingsValue = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('WhiteLabelSettings'),
    value: typebox_1.Type.Object({
        color: typebox_1.Type.Optional(typebox_1.Type.String()),
        dumpsters: typebox_1.Type.Array(typebox_1.Type.Object({
            size: typebox_1.Type.Number(),
            s3ItemReference: common_1.S3ItemReference,
            url: typebox_1.Type.Optional(typebox_1.Type.String()),
        })),
    }),
});
exports.HaulerPreferenceValue = typebox_1.Type.Union([
    exports.HaulerPreferenceBooleanValue,
    exports.HaulerPreferenceStringValue,
    exports.HaulerPreferenceNumberValue,
    exports.WaysteTaxableLineItemsValue,
    exports.StopCardFieldCustomizationValue,
    exports.OnlineCheckoutDaysOfWeekDisabledValue,
    exports.OnlineCheckoutSpecificDatesDisabledValue,
    exports.WhiteLabelSettingsValue,
]);
exports.HaulerPreferenceValueInternal = typebox_1.Type.Union([
    typebox_1.Type.Boolean(),
    typebox_1.Type.String(),
    typebox_1.Type.Number(),
    typebox_1.Type.Array(typebox_1.Type.String()),
    exports.StopCardFieldCustomizationValue.value,
    exports.OnlineCheckoutDaysOfWeekDisabledValue.value,
    exports.OnlineCheckoutSpecificDatesDisabledValue.value,
    exports.WhiteLabelSettingsValue.value,
]);
exports.HaulerPreferenceValueValidation = typebox_1.Type.Object({
    type: typebox_1.Type.String(),
    value: exports.HaulerPreferenceValueInternal,
});
const USE_DUMP = typebox_1.Type.Literal('useDump');
const TAXABLE_LINE_ITEMS = typebox_1.Type.Literal('taxableLineItems');
const TAXABLE_LINE_ITEMS_SOURGUM = typebox_1.Type.Literal('taxableLineItemsSourgum');
const FEATURE_FLAG_WAYSTE_COMMERCIAL = typebox_1.Type.Literal('featureFlagWaysteCommercial');
const FEATURE_FLAG_WAYSTE_WHITELABEL = typebox_1.Type.Literal('featureFlagWaysteWhiteLabel');
const ENFORCE_AVAILABILITY_FOR_ONLINE_BOOKING = typebox_1.Type.Literal('enforceAvailabilityForOnlineBooking');
const ENABLE_SERVICE_AGREEMENTS = typebox_1.Type.Literal('enableServiceAgreements');
const ALWAYS_SHOW_REMITTANCE_INFO_ON_UNPAID_INVOICES = typebox_1.Type.Literal('alwaysShowRemittanceInfoOnUnpaidInvoices');
const ACH_REMITTANCE_INFO = typebox_1.Type.Literal('achRemittanceInfo');
const ADD_MISSING_PAYMENT_FEE_ON_WAYSTE_DASHBOARD = typebox_1.Type.Literal('addMissingPaymentFeeOnWaysteDashboard');
const STOP_CARD_FIELD_CUSTOMIZATION = typebox_1.Type.Literal('stopCardFieldCustomization');
// Online Checkout Availability Preference Keys
const ONLINE_CHECKOUT_DAYS_OF_WEEK_DISABLED = typebox_1.Type.Literal('onlineCheckoutDaysOfWeekDisabled');
const ONLINE_CHECKOUT_SPECIFIC_DATES_DISABLED = typebox_1.Type.Literal('onlineCheckoutSpecificDatesDisabled');
const ONLINE_CHECKOUT_ADVANCE_DAYS = typebox_1.Type.Literal('onlineCheckoutAdvanceDays');
const ONLINE_CHECKOUT_CUTOFF_TIME = typebox_1.Type.Literal('onlineCheckoutCutoffTime');
//////////////////////////////////////////////////////
// Notification preferences
//////////////////////////////////////////////////////
const ENABLE_EN_ROUTE_ROLL_OFF_NOTIFICATIONS = typebox_1.Type.Literal('ROLL_OFF_DRIVER_ENROUTE');
const ENABLE_ORDER_CANCELLATION_ROLL_OFF_NOTIFICATIONS = typebox_1.Type.Literal('ROLL_OFF_ORDER_CANCEL');
const ENABLE_ROLL_OFF_DAY_OF_SERVICE_REMINDER = typebox_1.Type.Literal('ROLL_OFF_DAY_OF_SERVICE_REMINDER');
const ENABLE_ROLL_OFF_DAY_BEFORE_SERVICE_REMINDER = typebox_1.Type.Literal('ROLL_OFF_DAY_BEFORE_SERVICE_REMINDER');
const ENABLE_WAYSTE_INVOICE_PAYMENT_RECEIPT = typebox_1.Type.Literal('WAYSTE_INVOICE_PAYMENT_RECEIPT');
const ENABLE_WAYSTE_AUTOPAY_RECEIPT = typebox_1.Type.Literal('WAYSTE_AUTOPAY_RECEIPT');
const ENABLE_WAYSTE_AUTOPAY_FAILURE = typebox_1.Type.Literal('WAYSTE_AUTOPAY_FAILURE');
const ENABLE_ROLL_OFF_ORDER_CONFIRMATION = typebox_1.Type.Literal('ROLL_OFF_ORDER_CONFIRMATION');
const ENABLE_ROLLOFF_INVOICE_PAYMENT = typebox_1.Type.Literal('ROLLOFF_INVOICE_PAYMENT');
const ENABLE_WAYSTE_INVOICE_ISSUE_RECEIPT = typebox_1.Type.Literal('WAYSTE_INVOICE_ISSUE_RECEIPT');
exports.HaulerPreferenceKey = typebox_1.Type.Union([
    USE_DUMP,
    TAXABLE_LINE_ITEMS,
    TAXABLE_LINE_ITEMS_SOURGUM,
    FEATURE_FLAG_WAYSTE_COMMERCIAL,
    FEATURE_FLAG_WAYSTE_WHITELABEL,
    ENFORCE_AVAILABILITY_FOR_ONLINE_BOOKING,
    ENABLE_SERVICE_AGREEMENTS,
    ALWAYS_SHOW_REMITTANCE_INFO_ON_UNPAID_INVOICES,
    ACH_REMITTANCE_INFO,
    ADD_MISSING_PAYMENT_FEE_ON_WAYSTE_DASHBOARD,
    ENABLE_EN_ROUTE_ROLL_OFF_NOTIFICATIONS,
    ENABLE_ORDER_CANCELLATION_ROLL_OFF_NOTIFICATIONS,
    ENABLE_ROLL_OFF_DAY_OF_SERVICE_REMINDER,
    ENABLE_ROLL_OFF_DAY_BEFORE_SERVICE_REMINDER,
    STOP_CARD_FIELD_CUSTOMIZATION,
    ENABLE_WAYSTE_AUTOPAY_RECEIPT,
    ENABLE_WAYSTE_AUTOPAY_FAILURE,
    ENABLE_WAYSTE_INVOICE_PAYMENT_RECEIPT,
    ENABLE_ROLL_OFF_ORDER_CONFIRMATION,
    ENABLE_ROLLOFF_INVOICE_PAYMENT,
    ENABLE_WAYSTE_INVOICE_ISSUE_RECEIPT,
    // Add Online Checkout Availability Preference Keys
    ONLINE_CHECKOUT_DAYS_OF_WEEK_DISABLED,
    ONLINE_CHECKOUT_SPECIFIC_DATES_DISABLED,
    ONLINE_CHECKOUT_ADVANCE_DAYS,
    ONLINE_CHECKOUT_CUTOFF_TIME,
]);
//////////////////////////////////////////////////////
// Actual preference types
//////////////////////////////////////////////////////
exports.UseDumpType = typebox_1.Type.Object({
    key: USE_DUMP,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.WaysteTaxableLineItemsType = typebox_1.Type.Object({
    key: TAXABLE_LINE_ITEMS,
    value: exports.WaysteTaxableLineItemsValue,
});
exports.FeatureFlagWaysteCommercialType = typebox_1.Type.Object({
    key: FEATURE_FLAG_WAYSTE_COMMERCIAL,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.FeatureFlagWaysteWhiteLabelType = typebox_1.Type.Object({
    key: FEATURE_FLAG_WAYSTE_WHITELABEL,
    value: exports.WhiteLabelSettingsValue,
});
exports.EnforceAvailabilityForOnlineBookingType = typebox_1.Type.Object({
    key: ENFORCE_AVAILABILITY_FOR_ONLINE_BOOKING,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.EnableServiceAgreementsType = typebox_1.Type.Object({
    key: ENABLE_SERVICE_AGREEMENTS,
    value: exports.HaulerPreferenceStringValue,
});
exports.AlwaysShowRemittanceInfoOnUnpaidInvoicesType = typebox_1.Type.Object({
    key: ALWAYS_SHOW_REMITTANCE_INFO_ON_UNPAID_INVOICES,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.AchRemittanceInfoType = typebox_1.Type.Object({
    key: ACH_REMITTANCE_INFO,
    value: exports.HaulerPreferenceStringValue,
});
exports.AddMissingPaymentFeeOnWaysteDashboardType = typebox_1.Type.Object({
    key: ADD_MISSING_PAYMENT_FEE_ON_WAYSTE_DASHBOARD,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.StopCardFieldCustomizationType = typebox_1.Type.Object({
    key: STOP_CARD_FIELD_CUSTOMIZATION,
    value: exports.StopCardFieldCustomizationValue,
});
// Online Checkout Availability Preferences Types
exports.OnlineCheckoutDaysOfWeekDisabledType = typebox_1.Type.Object({
    key: ONLINE_CHECKOUT_DAYS_OF_WEEK_DISABLED,
    value: exports.OnlineCheckoutDaysOfWeekDisabledValue,
});
exports.OnlineCheckoutSpecificDatesDisabledType = typebox_1.Type.Object({
    key: ONLINE_CHECKOUT_SPECIFIC_DATES_DISABLED,
    value: exports.OnlineCheckoutSpecificDatesDisabledValue,
});
exports.OnlineCheckoutAdvanceDaysType = typebox_1.Type.Object({
    key: ONLINE_CHECKOUT_ADVANCE_DAYS,
    value: exports.HaulerPreferenceNumberValue,
});
exports.OnlineCheckoutCutoffTimeType = typebox_1.Type.Object({
    key: ONLINE_CHECKOUT_CUTOFF_TIME,
    value: exports.HaulerPreferenceStringValue,
});
//////////////////////////////////////////////////////
// Notification preferences
//////////////////////////////////////////////////////
exports.EnableEnRouteNotificationsType = typebox_1.Type.Object({
    key: ENABLE_EN_ROUTE_ROLL_OFF_NOTIFICATIONS,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.EnableOrderCancellationNotificationsType = typebox_1.Type.Object({
    key: ENABLE_ORDER_CANCELLATION_ROLL_OFF_NOTIFICATIONS,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.EnableRollOffDayOfServiceReminderType = typebox_1.Type.Object({
    key: ENABLE_ROLL_OFF_DAY_OF_SERVICE_REMINDER,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.EnableRollOffDayBeforeServiceReminderType = typebox_1.Type.Object({
    key: ENABLE_ROLL_OFF_DAY_BEFORE_SERVICE_REMINDER,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.EnableWaysteAutopayReceiptType = typebox_1.Type.Object({
    key: ENABLE_WAYSTE_AUTOPAY_RECEIPT,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.EnableWaysteAutopayFailureType = typebox_1.Type.Object({
    key: ENABLE_WAYSTE_AUTOPAY_FAILURE,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.EnableRollOffOrderConfirmationType = typebox_1.Type.Object({
    key: ENABLE_ROLL_OFF_ORDER_CONFIRMATION,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.EnableRollOffInvoicePaidType = typebox_1.Type.Object({
    key: ENABLE_ROLLOFF_INVOICE_PAYMENT,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.EnableWaysteInvoicePaymentReceiptType = typebox_1.Type.Object({
    key: ENABLE_WAYSTE_INVOICE_PAYMENT_RECEIPT,
    value: exports.HaulerPreferenceBooleanValue,
});
exports.EnableWaysteInvoiceIssueReceiptType = typebox_1.Type.Object({
    key: ENABLE_WAYSTE_INVOICE_ISSUE_RECEIPT,
    value: exports.HaulerPreferenceBooleanValue,
});
//////////////////////////////////////////////////////
// These types with "validation" in the name are used to get around a quirk in Fastify where
// it doesn't handle discriminated unions correctly in its request and response validations.
// Front-end clients should use the non-validation types.
//////////////////////////////////////////////////////
// Hauler Transport Types
//////////////////////////////////////////////////////
exports.HaulerPreferenceTransport = typebox_1.Type.Union([
    exports.UseDumpType,
    exports.WaysteTaxableLineItemsType,
    exports.FeatureFlagWaysteCommercialType,
    exports.FeatureFlagWaysteWhiteLabelType,
    exports.EnforceAvailabilityForOnlineBookingType,
    exports.EnableServiceAgreementsType,
    exports.AlwaysShowRemittanceInfoOnUnpaidInvoicesType,
    exports.AchRemittanceInfoType,
    exports.AddMissingPaymentFeeOnWaysteDashboardType,
    exports.EnableEnRouteNotificationsType,
    exports.EnableOrderCancellationNotificationsType,
    exports.EnableRollOffDayOfServiceReminderType,
    exports.EnableRollOffDayBeforeServiceReminderType,
    exports.StopCardFieldCustomizationType,
    exports.EnableWaysteAutopayReceiptType,
    exports.EnableWaysteAutopayFailureType,
    exports.EnableRollOffOrderConfirmationType,
    exports.EnableRollOffInvoicePaidType,
    exports.EnableWaysteInvoicePaymentReceiptType,
    exports.EnableWaysteInvoiceIssueReceiptType,
    // Add Online Checkout Availability Preferences to Transport Union
    exports.OnlineCheckoutDaysOfWeekDisabledType,
    exports.OnlineCheckoutSpecificDatesDisabledType,
    exports.OnlineCheckoutAdvanceDaysType,
    exports.OnlineCheckoutCutoffTimeType,
]);
exports.HaulerPreferencesTransport = typebox_1.Type.Object({
    preferences: typebox_1.Type.Array(exports.HaulerPreferenceTransport),
});
//////////////////////////////////////////////////////
// Hauler Transport Validation Types
//////////////////////////////////////////////////////
// These types with "validation" in the name are used to get around a quirk in Fastify where
// it doesn't handle discriminated unions correctly in its request and response validations.
// Front-end clients should use the non-validation types.
exports.HaulerPreferenceTransportValidation = typebox_1.Type.Object({
    key: exports.HaulerPreferenceKey,
    value: exports.HaulerPreferenceValue,
});
exports.HaulerPreferencesTransportValidation = typebox_1.Type.Object({
    preferences: typebox_1.Type.Array(exports.HaulerPreferenceTransportValidation),
});
//# sourceMappingURL=hauler-preferences-transport.js.map